import { Customer } from '../models/customer';
import { Employment, EmploymentStatusEnum } from '../models/employment';
import { EmploymentInviteeStatusEnum } from '../models/employmentInviteeStatusEnum';

export enum EvaluatedEmploymentStatusEnum {
  PENDING = 'PENDING',
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  HAS_AVAILABLE_INVITEES = 'HAS_AVAILABLE_INVITEES',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED',
  ARCHIVED = 'ARCHIVED',
}

export function getEvaluatedEmploymentStatus(
  employment: Employment,
  currentCustomer: Customer,
): EvaluatedEmploymentStatusEnum {
  if (employment.status === EmploymentStatusEnum.CLOSED) {
    if (
      employment.invitees.some(
        (invitee) =>
          invitee.status === EmploymentInviteeStatusEnum.BOOKED &&
          invitee.customer.id === currentCustomer._id,
      ) ||
      employment.customer.id === currentCustomer._id ||
      employment.ownerCustomerIds?.includes(currentCustomer._id)
    ) {
      return EvaluatedEmploymentStatusEnum.CLOSED;
    } else {
      return EvaluatedEmploymentStatusEnum.ARCHIVED;
    }
  }

  let invitees = employment.invitees || [];
  // if the job is from another customer only count own invitees
  if (currentCustomer._id !== employment.customer.id) {
    invitees = employment.invitees.filter(
      (invitee) => invitee.customer.id === currentCustomer._id,
    );
  }
  if (
    employment.status === EmploymentStatusEnum.ARCHIVED &&
    employment.invitees.some(
      (i) => i.status === EmploymentInviteeStatusEnum.BOOKED,
    )
  ) {
    return EvaluatedEmploymentStatusEnum.CLOSED;
  }
  const hasAvailableInvitees = invitees.some(
    (invitee) =>
      invitee.status === EmploymentInviteeStatusEnum.AVAILABLE ||
      invitee.status === EmploymentInviteeStatusEnum.POSSIBLE_CANDIDATE,
  );
  if (hasAvailableInvitees) {
    return EvaluatedEmploymentStatusEnum.HAS_AVAILABLE_INVITEES;
  }
  const hasPendingInvitees = invitees.some(
    (invitee) => invitee.status === EmploymentInviteeStatusEnum.OPEN,
  );
  if (
    hasPendingInvitees ||
    (currentCustomer.transferredJobsNoLongerActionRequired &&
      employment.transfers?.some((t) => t.transferredAt))
  ) {
    return EvaluatedEmploymentStatusEnum.PENDING;
  }

  if (employment.status === EmploymentStatusEnum.ARCHIVED) {
    return EvaluatedEmploymentStatusEnum.ARCHIVED;
  }
  if (employment.status === EmploymentStatusEnum.CANCELED) {
    return EvaluatedEmploymentStatusEnum.CANCELED;
  }
  return EvaluatedEmploymentStatusEnum.ACTION_REQUIRED;
}
